import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type RefreshIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const RefreshIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: RefreshIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.992 12.0322C19.984 14.0692 19.211 16.1032 17.657 17.6572C14.533 20.7812 9.46701 20.7812 6.34301 17.6572C5.78701 17.1012 5.33501 16.4822 4.97701 15.8262"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.004 11.87C4.036 9.866 4.814 7.872 6.343 6.343C9.467 3.219 14.533 3.219 17.657 6.343C18.213 6.899 18.665 7.518 19.023 8.174"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.953 8.17516H19.488V4.63916"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.04699 15.8252H4.51199V19.3612"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
